import { SupplierRegistrationCountryFields } from '@supplierRegistration/domain/supplierRegistrationCountryFields';

enum SpainLegalIdTypesForCompany {
  CIF = 'CIF',
  NIE = 'NIE',
  VAT = 'VAT',
  Other = 'Other',
}

export const ES: SupplierRegistrationCountryFields = {
  leis: { types: SpainLegalIdTypesForCompany },
};
